/*
*   url存放地址
* */

export const CURL = "http://ts.winwulian.com"



// WEBPACK FOOTER //
// ./src/lib/url.js